import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import {
  mattaverseOrchestrationApiRef,
  MattaverseOrchestrationClient,
} from './api';

export const mattaverseOrchestrationPlugin = createPlugin({
  id: 'mattaverse-orchestration',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: mattaverseOrchestrationApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new MattaverseOrchestrationClient(discoveryApi, fetchApi),
    }),
  ],
});

export const MattaverseOrchestrationPage =
  mattaverseOrchestrationPlugin.provide(
    createRoutableExtension({
      name: 'MattaverseOrchestrationPage',
      component: () =>
        import('./components/MattaverseOrchestrationPage').then(
          m => m.MattaverseOrchestrationPage,
        ),
      mountPoint: rootRouteRef,
    }),
  );
